// extracted by mini-css-extract-plugin
export default {"dislike":"dislike_dislike__8O8e3"};